import { ReactElement } from "react";

export const CardMetaAccomodation = ({
  item,
}: {
  item: Travelguide.Accomodation;
}): ReactElement => (
  <div className="flex flex-row justify-between">
    <p>{item.category.name}</p>
    <p className="whitespace-nowrap">ab {item.price}</p>
  </div>
);
